export function MultilineText({ text }: { text: string | undefined }) {
  return (
    <>
      {text?.split(/\r?\n/).map((splittedText, key) => { return <div key={key}>{splittedText}</div>; })}
    </>
  );
}